(function($) {
  let baseFontSize = 16;
  let filter_page = 1;

	$(document).ready(function() {
    $('.filters-layout #post-tax-filters select, #post-attribute-filters input[type="checkbox"], #sort_by').on('change', dinamoHandleFiltersQueryParams);
    $('.filters-layout .dinamo-slider-input').on('input', debounce(dinamoHandleFiltersQueryParams, 250));

    $('body').on('click', '.filters-layout #filters-pagination a, .filters-layout .dinamo-filters-more a', dinamoHandleFiltersQueryParams);
    $('.filters-layout #post-filters-form').on('submit', dinamoHandleFiltersQueryParams);

    $(document).on('click', '#filtered_scroll_top', dinamoScrollTopFilters);
    $(document).on('click', '.dinamo-open-filters', dinamoToggleFilters);
    $(document).on('click', '.category_filters_link',dinamoToggleCategorieFilters )

    $('#filters-text-search').on('keyup', debounce(function(){
      $('#post-filters-form').submit();
    },400));
    $('#filters-text-search').on('search', function(){
      $('#post-filters-form').submit();
    });
  
    if(history.pushState){
      let search_params_load = new URLSearchParams(window.location.search);
      filter_page = search_params_load.get('filter_page');

      if(filter_page){
        let content_height = $('#filtered-content-container').outerHeight();
        
        let each_page_height = content_height/filter_page;
        //Set max-height to one page
        $('#post-filters-form #filtered-content').css('max-height', pxToRem(each_page_height - ($('.dinamo-model-block').outerHeight() - 100)) + "rem");
        //Scroll to page
        $('#post-filters-form #filtered-content').scrollTop((each_page_height * (filter_page-1)) + ($('.dinamo-model-block').outerHeight()*2) + 150);
      }
    }
  })

  function pxToRem(pxValue) {
    const remValue = pxValue / baseFontSize;

    return remValue;
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);

    method._tId = setTimeout(function () {
      method();
    }, delay);
  }
  
  /**
   * Function called when a filter checkbox changes, a pagination change is requested or when the search input has been submitted.
   * Used to dynamically add the filter params to the URL. We add the filters to the URL to make sure that when a user clicks "back" in his browser, he will keep the filters he was on.
   * When all the filters are in the URL, it triggers the AJAX call to refresh the content based on the URL parameters.
   */
  function dinamoHandleFiltersQueryParams(e){
    // If the browser supports pushState
    if(history.pushState){
      let search_params = new URLSearchParams(window.location.search);
      let all_tax_names = [];
      
      //Creates an array of all the taxonomies that can be filtered by parsing the checkboxes
      $('#post-tax-filters select').each(function() {
        if(all_tax_names.indexOf($(this).data('taxonomy')) == -1){
          all_tax_names.push($(this).data('taxonomy'));
        }
      });

      $('#post-attribute-filters input[type="checkbox"]').each(function () {
        if (all_tax_names.indexOf($(this).data('taxonomy')) == -1) {
          all_tax_names.push($(this).data('taxonomy'));
        }
      });

      if (all_tax_names.indexOf($('#post-slider-budget').data('taxonomy')) == -1) {
        all_tax_names.push($('#post-slider-budget').data('taxonomy'));
      }

      //Append all selected term IDs for all the taxonomies to the URL
      $.each(all_tax_names, (index, taxonomy_name) => {
        let selected_terms = [];
        
        $('#post-tax-filters select[data-taxonomy="'+taxonomy_name+'"] option:checked').each(function() {
          if($(this).val()){
            selected_terms.push($(this).val());
          }
        });

        $('#post-attribute-filters input[data-taxonomy="' + taxonomy_name + '"]:checked').each(function () {
          selected_terms.push($(this).val());
        });

        $('#post-slider-budget[data-taxonomy="' + taxonomy_name + '"] input').each(function () {
          if($(this).index() + 1 == Math.round($('#post-slider-filters .dinamo-slider-input').val()) && $(e.target).parent().attr('id') == 'post-slider-filters'){
            selected_terms.push($(this).val());
          }
        });
        let filter_name = taxonomy_name + '_filters';
        if(selected_terms.length > 0){
          search_params.set(filter_name, selected_terms.join());
        }
        else{
          search_params.delete(taxonomy_name + '_filters');
        }
      });

      //If the clicked object is a pagination link
      if($(this).hasClass('page-numbers')){
        e.preventDefault();
        let pagination_link = $(this).attr('href');
        let page_number_matches = pagination_link.match(/\/page\/(\d*)/);
        //If the regex found matches for a page number
        if(page_number_matches){
          search_params.set('filter_page', page_number_matches[1]);
        }
        else{
          //If there's no page number found, remove the page param
          search_params.delete('filter_page');
        }
      }
      else if($(this).data('taxonomy') || $(this).is('input[type=range]') || e.target.id == 'sort_by'){
        //If it's a filter checkbox has changed, reset the pagination so we go back to the first page
        search_params.delete('filter_page');
      }
      else if($(this).is('form')){
        //If the search input has been submitted, set the search URL param
        if($('#filters-text-search').val()){
          search_params.set('search', $('#filters-text-search').val());
        }
        else{
          search_params.delete('search');
        }
        //Reset the pagination so we go back to the first page
        search_params.delete('filter_page');
      }

      // The new url string
      let new_url = window.location.protocol + "//" + window.location.host + window.location.pathname;

      if(search_params.toString()){
        new_url += '?' + search_params.toString();
      }
      window.history.pushState({path: new_url}, '', new_url);

      //Trigger the content refresh
      dinamoRefreshFilteredContent(search_params.toString());
    }

    return false;
  }

  /**
   * Function making an AJAX request in order to refresh the content based on the filters.
   * @todo: Slow the query and add a loading screen.
   * @param {string} search_params: Query string containing all the filters
   */
  function dinamoRefreshFilteredContent(search_params){
    let $results_container = $('#filtered-content');
    
    if($results_container.length > 0){
      let urlParams = new URLSearchParams(search_params);
      let sector_id = "";
      let post_types = [];

      // If Sort By select change, append to the URL
      let sort_by = null;

      $('#sort_by option:checked').each(function() {
        if($(this).val()){
          sort_by = $(this).val();
        }
      });

      $('input[name="filters-post-type"]').each(function(){
        if($(this).val()){
          post_types.push($(this).val());
        }
      })

      sector_id = $('input[name="sector-id"]').val();

      $.ajax({
        url: ajax.url + '?' + search_params,
        type: 'GET',
        data: {
          action: 'dinamo_filtered_content',
          post_type: post_types,
          sector_id: sector_id,
          sort_by: sort_by
        },
        beforeSend: function () {
          $('.dinamo-loading-container').addClass('loading');
          $('.dinamo-filters-more a.page-numbers').hide();
        },
        success: function(result) {
          $('.dinamo-filters-more a.page-numbers').show();
          $('.dinamo-loading-container').removeClass('loading');

          $results_container.empty();
          $results_container.append(result);

          let new_position = $('#filters-anchor').offset().top;

          $('html, body').stop().animate({ scrollTop: new_position });          
        }
      });
    }
  }

  function dinamoScrollTopFilters(){
    let anchor_position = $('#filters-anchor').offset().top;
    $('html, body').stop().animate({ scrollTop: anchor_position });
  }

  var debounce = function (func, wait, immediate) {
    var timeout;

    return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
  };

  function dinamoToggleFilters(){
    if(!$('.dinamo-filters-panel').hasClass('closed')) {
      $('.dinamo-filters-panel').addClass('closed');
    }

    $('.dinamo-filters-panel').toggleClass('opened');
  }

  function dinamoToggleCategorieFilters() {
    const filterCategoriesContainer = $('#post-tax-filters');
    const isHidden = filterCategoriesContainer.hasClass('hidden');
    if (isHidden) {
      $('.category_filters_link').addClass('categories-active');
      filterCategoriesContainer.removeClass('hidden').addClass('flex');
    } else {
      $('.category_filters_link').removeClass('categories-active');
      filterCategoriesContainer.removeClass('flex').addClass('hidden');
    }
  }
})(jQuery);
